'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _handleActions;

var _fluxActions = require('flux-actions');

var _Immutable = require('Immutable');

var _ActionTypes = require('MeetingsLib/redux/actions/ActionTypes');

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = (0, _Immutable.Map)();

exports.default = (0, _fluxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _ActionTypes2.default.MEETING_CREATE_FAILED, function (requestStatus, action) {
  return requestStatus.set('meetingCreate', action.payload.error);
}), _defineProperty(_handleActions, _ActionTypes2.default.PUBLIC_AVAILABILITY_INFO_FETCH_FAILED, function (requestStatus, action) {
  return requestStatus.set('publicAvailabilityInfoFetch', action.payload.error);
}), _defineProperty(_handleActions, _ActionTypes2.default.USER_PROFILE_FETCH_FAILED, function (requestStatus, action) {
  return requestStatus.set('userProfileFetch', action.payload.error);
}), _handleActions), initialState);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/reducers/networkErrors.js
// module id = 519
// module chunks = 0